<mat-calendar
  (isEnglish)="setCalendarLocale($event)"
  [headerComponent]="customCalendarHeaderComponent"
  [dateFilter]="dateFilter()"
  [dateClass]="dateClass()"
  (selectedChange)="onSelect($event)"
  (viewChanged)="calendar().updateTodaysDate()"
/>
